export default __webpack_public_path__ + "static/gta_roofing_3-d29cad42945b96c48de18b98d6daf7fd.jpg";